<template>
  <div>
    <div class="sku-info-header__wrapper">
      <div class="sku-base-info__wrapper">
        <div class="sku-img__wrapper">
          <div class="div_box">
            <el-image
              :src="
                formData.defaultImageUrl
                  ? $osscdn(formData.defaultImageUrl)
                  : '/image/static/img/nopic-square.jpg'
              "
              :preview-src-list="[
                formData.defaultImageUrl
                  ? $osscdn(formData.defaultImageUrl)
                  : '/image/static/img/nopic-square.jpg',
              ]"
            >
              <div slot="error" class="image-slot">
                <img src="/image/static/img/nopic-square.jpg" />
              </div>
            </el-image>
          </div>
        </div>
        <div class="info__wrapper">
          <el-descriptions
            class="border-detail-main-form"
            border
            size="small"
            :column="3"
          >
            <el-descriptions-item
              :label="$l('INDEX.evg_sku_label_specNo') || '规格编号'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '150px' }"
            >
              {{ formData.specNo || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :label="'NC编号'"
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '150px' }"
            >
              {{ formData.specNcNo || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
              :label="$l('INDEX.evg_sku_label_update_time') || '更新时间'"
            >
              {{ formData.modifyByName || '--' }} at
              {{ formData.modifyDate || '--' }}
            </el-descriptions-item>
          </el-descriptions>
          <el-descriptions
            border
            class="border-detail-main-form"
            size="small"
            :column="2"
          >
            <el-descriptions-item
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
              :label="$l('INDEX.evg_sku_label_specName') || '规格名称'"
            >
              {{ formData.specName || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
              :label="$l('INDEX.evg_sku_label_specEn') || '英文名称'"
            >
              {{ formData.specNameEn || '' }}
            </el-descriptions-item>
          </el-descriptions>

          <el-descriptions border size="small" :column="3">
            <el-descriptions-item
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '400px' }"
              :label="$l('INDEX.evg_sku_label_goodsSize') || '规格尺寸'"
            >
              {{ formData.v_goodsSize || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelStyle="{ width: '100px' }"
              :contentStyle="{ width: '150px' }"
              :label="$l('INDEX.evg_sku_label_specQty') || '规格数量'"
            >
              {{ formData.specQty || '' }}
            </el-descriptions-item>
            <el-descriptions-item
              :labelStyle="{ width: '100px' }"
              :contentStyle="{
                width: '150px',
                padding: '0px !important',
              }"
              :label="$l('INDEX.evg_sku_label_Operation') || '功能操作'"
            >
              <div class="ml-2" v-if="!disabled && !isFormal">
                <i
                  class="el-icon-edit tool-btn"
                  @click="$emit('updateSpec', formData)"
                ></i>
                <i
                  class="el-icon-delete tool-btn"
                  style="color: red;"
                  @click="$emit('delSpec', formData)"
                ></i>
              </div>
              <div class="ml-2" v-if="!disabled && isFormal">
                <el-tooltip
                  effect="dark"
                  :content="$l('INDEX.btn_editImage') || '编辑图片'"
                  placement="top"
                >
                  <i
                    class="el-icon-picture-outline tool-btn"
                    @click="$emit('editImage', formData)"
                  />
                </el-tooltip>
              </div>
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'

export default {
  props: {
    specInfo: { type: Object, default: () => {} },
    currIndex: { type: Number, default: -1 },
    evgSkuCode: { type: String, default: '' },
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
  },
  mixins: [EditLoading],
  components: {},
  data() {
    return {
      formData: {},
      showImageChoose: false,
      rules: {
        specNo: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        specName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        specNameEn: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        goodsLength: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        goodsWidth: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        goodsHeight: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
        specUnit: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        specQty: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入',
          },
        ],
      },
    }
  },
  watch: {
    specInfo: {
      handler() {
        this.formData = { ...this.specInfo }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {},
}
</script>
<style lang="scss" scoped>
.sku-info-header__wrapper {
  padding: 16px 16px 0 16px;
  background-color: white;
  border-radius: 5px;
  overflow: hidden;
  .sku-base-info__wrapper {
    display: flex;
    align-items: center;
    .info__wrapper {
      flex: 1;
    }
    .sku-img__wrapper {
      width: 120px;
      height: 118px;
      border: 1px solid #e8e8e8;
      border-right: 0px;
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
      display: flex;
      justify-content: center;
      align-items: center;
      .div_box {
        width: 100px;
        height: 100px;
        border: 1px dashed #cecece;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;
        .el-image {
          border-radius: 5px;
          width: 90px;
          height: 90px;
        }
      }
    }
  }
}

::v-deep {
  .el-descriptions--small.is-bordered .el-descriptions-item__cell {
    padding: 10px 10px !important;
  }
  .border-detail-main-form {
    .el-descriptions-item__cell {
      border-bottom: 0px !important;
    }
  }
}
</style>
